import { createFileRoute } from "@tanstack/react-router";
import { Text } from "../../ui/components/Text";
import { useAuth } from "../lib/auth/hooks";
import { requireAuth } from "../lib/auth/route-protection";

export const Route = createFileRoute("/")({
  beforeLoad: requireAuth(),
  component: IndexComponent,
});

function IndexComponent() {
  const { user } = useAuth();

  return (
    <div style={{ padding: "32px 24px", fontFamily: "Inter, sans-serif" }}>
      <Text level="h1" color="primary" weight="bold" style={{ marginBottom: 8 }}>
        Home
      </Text>
      {user && (
        <Text level="body-medium" style={{ color: "#6B7280" }}>
          Welcome back, {user.firstName} {user.lastName}.
        </Text>
      )}
      <p style={{ marginTop: 24, fontSize: 14, color: "#9CA3AF" }}>
        Dashboard content will appear here in a future release.
      </p>
    </div>
  );
}
